import { useState } from "react";
import { Button } from "components/ui/button";

interface InactivateConfirmModalProps {
  campaignName: string;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;

  isLoading?: boolean;
}

export function InactivateConfirmModal({
  campaignName,
  onConfirm,
  onCancel,
  isLoading = false,
}: InactivateConfirmModalProps) {

  const [isSubmitting, setIsSubmitting] = useState(false);
  const busy = isSubmitting || isLoading;

  const handleConfirm = async () => {
    if (busy) return;
    setIsSubmitting(true);
    try {
      await onConfirm();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-4">
      <h3 className="text-lg font-medium mb-4">Confirmar Inativação</h3>
      <p className="text-sm text-gray-600 mb-6">
        Tem certeza que deseja inativar a campanha "{campaignName}"? A campanha
        ficará indisponível para uso.
      </p>
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={onCancel} disabled={busy}>
          Cancelar
        </Button>
        <Button variant="destructive" onClick={handleConfirm} disabled={busy}>
          {busy ? "Inativando..." : "Inativar"}
        </Button>
      </div>
    </div>
  );
}
